module.exports = __webpack_public_path__ + "img/vegetable-collard-greens-190x100.0a3ec075.jpg";